import React, { FC } from "react";

import { BannerProps } from "./models";
import { Wrapper, Content } from "./styles";

const InviteFriendsBanner: FC<BannerProps> = ({ onClick }) => {
  return (
    <Wrapper>
      <Content>
        <h2>
          Get <span>$100</span> off your fee
        </h2>
        <p>Invite a friend to invest in this startup.</p>
        <button type="button" onClick={onClick}>
          Share & earn
        </button>
      </Content>
    </Wrapper>
  );
};

export default InviteFriendsBanner;
